/* eslint-disable */
import React, { useEffect } from "react";
import BASE_URL from "./auth/Baseurl";
import axios from "axios";

const CancellingPolicy = (props) => {
  const { cancelling, setCancelling, formData, setFormData, errors } = props;

  const GetData = () => {
    axios
      .get(`${BASE_URL}/cancellation-policy`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        console.log(res?.data, "cancelling");
        setCancelling(res.data?.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetData();
  }, []);

  // Handle selection change
  const handleSelectChange = (event) => {
    const selectedPolicy = event.target.value;
    // Update only the 'cancellation_policy' field while preserving the rest of the form data
    setFormData((prevFormData) => ({
      ...prevFormData,
      cancellation_policy: selectedPolicy,
    }));
  };
  console.log(formData?.cancellation_policy, "valuescan");

  return (
    <div className="md:col-span-12 text-left">
      <label>
        Cancellation Policy
        <i className="fal fa-times-circle" />
      </label>
      <select
        data-placeholder="Apartments"
        className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${
          errors.cancellation_policy ? "error" : ""
        }`}
        name="cancellation_policy"
        value={formData.cancellation_policy || ""}
        onChange={handleSelectChange}
      >
        <option disabled value="">
          Select
        </option>
        {cancelling?.map((item, index) => (
          <option key={index} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
      {errors.cancellation_policy && (
        <span style={{ color: "red" }}>{errors.cancellation_policy}</span>
      )}
    </div>
  );
};

export default CancellingPolicy;
